var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"mk-app",attrs:{"id":"app"}},[_c('v-content',{staticClass:"mk-content"},[_c('div',{staticClass:"mk-content-background"},[_c('Home')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }